import { FC } from 'react'

import { createPortal } from 'react-dom'
import { twMerge } from 'tailwind-merge'

interface Props {
  isOpen: boolean
  position: { top: number; left: number }
  selectedScore: number
  onSelect: (score: number) => void
  onMouseEnter: () => void
  onMouseLeave: () => void
}

export const ScoringDropdown: FC<Props> = ({
  isOpen,
  position,
  selectedScore,
  onSelect,
  onMouseEnter,
  onMouseLeave,
}) => {
  const scoringOptions = Array.from({ length: 10 }, (_, index) => index + 1)

  if (!isOpen) return null

  return createPortal(
    <div
      className="fixed bg-card border border-border rounded-lg shadow-lg p-3 z-[9999] min-w-max"
      style={{
        top: position.top,
        left: position.left,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between gap-2 text-xs text-text-muted">
          <span>Poor</span>
          <span>Excellent</span>
        </div>
        <div className="flex flex-row dark:bg-secondary-400 bg-secondary-100 gap-1 rounded-xl px-1 py-0.5">
          {scoringOptions.map((option) => (
            <span
              key={option}
              onClick={() => onSelect(option)}
              className={twMerge(
                'text-sm font-medium px-1.5 rounded-xl hover:bg-primary-500 cursor-pointer hover:text-neutral-default',
                selectedScore === option &&
                  'bg-primary-500 text-neutral-default',
              )}
            >
              {option}
            </span>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  )
}
